import { useState } from 'react';

const Field = ({ label, required, description, apiMapping, helperText, type }) => (
  <div className="mb-6">
    <label className="block font-mono font-bold text-blue-600">
      {label} <span className="text-black">{type}</span>{' '}
      {required && <span className="text-sm text-red-600">*required*</span>}
    </label>
    <p className="text-sm text-gray-600">{description}</p>
    {helperText && <p className="mt-1 text-xs text-blue-500">{helperText}</p>}
  </div>
);

const CustomDataTypes = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="max-w-xl p-4 mx-auto">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="mb-4 button button-primary has-arrow has-arrow-white"
      >
        {isExpanded ? 'Hide customDataTypes Params' : 'Show customDataTypes Params'}
      </button>

      {isExpanded && (
        <div className="p-6 border border-gray-200 rounded-lg shadow">
          <Field
            label="type"
            required
            description="The name to be returned to you during validation events"
            type="string"
          />
          <Field
            label="validRegex"
            type="string"
            required
            description="Regular expression used to validate the input."
          />
          <Field
            label="possibleRegEx"
            type="string"
            required
            apiMapping="data.iframeConfiguration.iqProV2.authenticationKey"
            description="Regular expression used to partially validate the input. This is commonly used to toggle logos/images of the brand detected while the user is typing."
          />
          <Field
            label="maxLength"
            type="string"
            required
            apiMapping="data.iframeConfiguration.iqProV2.timestamp"
            description="Max length of the expected input."
          />
          <Field
            label="cvvValidRegex"
            type="string"
            description="Required when in PCI w/CVV or CVV Only mode"
          />
          <Field
            label="cvvMaxLength"
            type="string"
            description="Required when in PCI w/CVV or CVV Only mode"
          />
          <Field
            label="cvvRequired"
            type="string"
            apiMapping="N/A"
            description="Allows a blank CVV input when false"
          />
          <Field
            label="luhnCheck"
            type="boolean"
            apiMapping="N/A"
            description={
              <>
                Indicates the system to verify Luhn compliance on custom card schemes
                <br />
                <br />
                Default value is set to True
                <br />
                <br />
                Note: - There will not be (Luhn compliance) format validation error if
                enforceLuhnCompliance parameter is set to false. <br />
                <br />
                This will suppress the JavaScript Luhn check error, allowing the user to send the
                request to the backend. However if the token scheme doesn't allow skipping the Luhn
                check, the token generation will still error.
              </>
            }
          />
        </div>
      )}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className={`my-4 button button-primary has-arrow has-arrow-white ${
          isExpanded ? '' : '!hidden'
        }`}
      >
        {isExpanded ? 'Hide customDataTypes Params' : 'Show customDataTypes Params'}
      </button>
    </div>
  );
};

export default CustomDataTypes;
